module.exports = __webpack_public_path__ + "static/media/overdrive_1.cd656d6c.svg";